import MenuItem from "@mui/material/MenuItem"
import { makeStyles } from "tss-react/mui"

import { createEnumChecker } from "../../../../../../lib/enums"
import { LocalizedEnum, LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { ResourceType } from "../../../../admin/organization/resources/resourcesTypes"

import { LabeledFilterSelect } from "../common/LabeledFilterSelect"
import { ALL_RESOURCE_TYPES, DASHBOARD_RESOURCE_TYPES, ResourceTypeSelection } from "./resourceDashboardTypes"

const isResourceTypeValue = createEnumChecker(ResourceType)

type ResourceTypeSelectionFilterProps = Readonly<{
    value: ResourceTypeSelection
    onChange: (value: ResourceTypeSelection) => void
}>

const useStyles = makeStyles()(() => ({
    field: {
        width: "15rem",
    },
}))

export function ResourceTypeSelectionFilter({ value, onChange }: ResourceTypeSelectionFilterProps) {
    const { classes } = useStyles()

    return (
        <LocalizedStrict id="table-select-resource-type-filter-by-label-label" attrs={{ label: true }}>
            <LabeledFilterSelect
                id="resource-dashboard-resource-type-select"
                label="Resource type"
                value={value}
                onChange={(next) => onChange(isResourceTypeValue(next) ? next : ALL_RESOURCE_TYPES)}
                className={classes.field}
            >
                <MenuItem value={ALL_RESOURCE_TYPES}>
                    <LocalizedStrict id="resource-dashboard-type-all">
                        <span>All types</span>
                    </LocalizedStrict>
                </MenuItem>
                {DASHBOARD_RESOURCE_TYPES.map((resourceType) => (
                    <MenuItem key={resourceType} value={resourceType}>
                        <LocalizedEnum base="resource-dashboard-type" enumValue={resourceType}>
                            <span>{resourceType}</span>
                        </LocalizedEnum>
                    </MenuItem>
                ))}
            </LabeledFilterSelect>
        </LocalizedStrict>
    )
}

